// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__2YB4q","active":"Tab_active__wRiZ0","activeIndicator":"Tab_activeIndicator__yJYzW"};